import { useRootLoaderData } from 'components/Root.loader'
import { useMemo } from 'react'

function useOcrBuilders() {
  const { verifyGroups, ocrBuilders } = useRootLoaderData()
  // ocrBuildersがnullの場合がある
  const normalOcrBuilders = useMemo(
    () =>
      !ocrBuilders
        ? []
        : ocrBuilders.filter(
            // 共通タイプは含む
            ({ subGroup }) => !subGroup || !verifyGroups.includes(subGroup),
          ),
    [ocrBuilders, verifyGroups],
  )
  const verifyOcrBuilders = useMemo(
    () =>
      !ocrBuilders
        ? []
        : ocrBuilders.filter(
            // 共通タイプは含まない
            ({ subGroup }) => verifyGroups.includes(subGroup),
          ),
    [ocrBuilders, verifyGroups],
  )

  return {
    ocrBuilders,
    normalOcrBuilders,
    verifyOcrBuilders,
  }
}

export default useOcrBuilders
